import React, { useState, useRef, useEffect } from 'react';
import { Validaciones } from '@renedelangel/helpers';
// Redux
import { useSelector } from 'react-redux';
// master components
import Tabla from '../../../_layout/masterComponents/Tabla';
import FormularioModal from '../../../_layout/masterComponents/FormularioModal';
// generic components
import Modal from '../../../_layout/genericComponents/Modal';
import SweetAlert from '../../../_layout/genericComponents/ModalConfirmacion';
import { NetworkError } from "../../../_layout/genericComponents/Metodos";
// material-ui icons
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import SyncIcon from '@material-ui/icons/Sync';
import SaveIcon from '@material-ui/icons/Save';
import EventNoteIcon from '@material-ui/icons/EventNote';
import HistoryIcon from '@material-ui/icons/History';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import PersonPinCircleIcon from '@material-ui/icons/PersonPinCircle';
import { RiFileExcel2Fill } from "react-icons/ri";

import { handleFocus, handleErrorInputText, handleModificar, handelAlertEliminar, handleEliminar, handleGuardar } from '../../../_layout/helpers/handles';
import { info, danger, success, primary } from '../../../_layout/helpers/colores';

import { getSeguimientoSeguros, tablaSeguimientoSeguros } from '../../../querys/SeguimientoSeguros';
import { addSeguimientoSeguros, updateSeguimientoSeguros, deleteSeguimientoSeguros } from '../../../mutations/SeguimientoSeguros';
import { getSeguimientoSemanalSeg, getAllSeguimientoSemanalSeg, tablaSeguimientoSemanalSeg, seleccionSeguimientosPrograma } from '../../../querys/SeguimientoSemanalSeg';
import { addSeguimientoSemanalSeg, updateSeguimientoSemanalSeg, deleteSeguimientoSemanalSeg } from '../../../mutations/SeguimientoSemanalSeg';
import { seleccionEjercicioSeguros, seleccionSemanaSeguros, seleccionEstadoSeguimiento, seleccionTipoSeguimiento, seleccionUsuarios } from '../../../querys/CatalogosSeguimiento';
import { seleccionEmpresa } from '../../../querys/Empresas';
import { seleccionResponsablesSeguro } from '../../../querys/ResponsablesSeguro';
import { getAllDivisa } from '../../../querys/Divisa';
import * as Permisos from '../Permisos';
import GenerarProgramaAnual from './GenerarProgramaAnual';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';

import moment from 'moment';
import { urlServidor } from '../../../helpers';

const { trim } = Validaciones;

// Celda de la columna Estado con el color del catálogo de estados (#RRGGBB)
function ftCeldaEstado(estado, color) {
    if (!color || !/^#[0-9A-Fa-f]{6}$/.test(String(color).trim())) return estado ? String(estado) : "";
    let fondo = String(color).trim();
    // Texto oscuro sobre colores claros (p. ej. el amarillo de EN PROCESO) y blanco sobre los oscuros
    let [r, g, b] = [1, 3, 5].map(i => parseInt(fondo.slice(i, i + 2), 16));
    let claro = (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6;
    return <div style={{
        backgroundColor: fondo,
        color: claro ? "#212121" : "#FFFFFF",
        fontWeight: "bold",
        textAlign: "center",
        padding: "4px 8px",
        borderRadius: "4px",
        whiteSpace: "nowrap"
    }}>{estado}</div>;
}

// Opciones del % de avance del seguimiento semanal: de 5 en 5 hasta 100.
// Se arma una lista nueva cada vez porque el autocomplete le agrega el valor capturado a mano
function ftOpcionesAvance() {
    return Array.from({ length: 20 }, (_, i) => {
        let porcentaje = String((i + 1) * 5);
        return { value: porcentaje, label: `${porcentaje}%` };
    });
}

function SeguimientoSeguros() {

    const { token, usuario } = useSelector(stDatos => stDatos.login);

    const cleanState = {
        seguimientoSeguroID: null,
        tipoSeguimientoID: "",
        empresaID: "",
        ramoSeguimiento: "",
        ejercicioID: "",
        semanaAltaID: "",
        estadoID: "",
        personalSeguimiento: "",
        responsableID: "",
        // Registro de origen (póliza); por ahora la póliza se captura a mano y no se llena
        origenID: null,
        origenTipo: "",
        usuarioID: usuario && usuario.usuarioID ? String(usuario.usuarioID) : "",
        folio: "",
        numpolEndoso: "",
        inciso: "",
        inicioVigencia: "",
        finVigencia: "",
        sumaAseg: "",
        primaNeta: "",
        primaTotal: "",
        fechaSolicitud: "",
        divisaID: "",
        descripcion: "",
        fechaIngreso: moment(),
        fechaSeguimiento: "",
        fechaAlta: moment(),
        avance: "0"
    };

    const cleanErrorState = {
        tipoSeguimientoID: { error: false, helperText: "" },
        empresaID: { error: false, helperText: "" },
        ramoSeguimiento: { error: false, helperText: "" },
        ejercicioID: { error: false, helperText: "" },
        semanaAltaID: { error: false, helperText: "" },
        estadoID: { error: false, helperText: "" },
        personalSeguimiento: { error: false, helperText: "" },
        responsableID: { error: false, helperText: "" },
        usuarioID: { error: false, helperText: "" },
        folio: { error: false, helperText: "" },
        numpolEndoso: { error: false, helperText: "" },
        inciso: { error: false, helperText: "" },
        inicioVigencia: { error: false, helperText: "" },
        finVigencia: { error: false, helperText: "" },
        sumaAseg: { error: false, helperText: "" },
        primaNeta: { error: false, helperText: "" },
        primaTotal: { error: false, helperText: "" },
        divisaID: { error: false, helperText: "" },
        descripcion: { error: false, helperText: "" },
        fechaIngreso: { error: false, helperText: "" },
        fechaSeguimiento: { error: false, helperText: "" },
        fechaAlta: { error: false, helperText: "" },
        avance: { error: false, helperText: "" },
        origenTipo: { error: false, helperText: "" }        
    };

    const cleanStateSemanal = {
        seguimientoSemanalSegID: null,
        avance: "",
        fechaSeguimiento: moment(),
        personalSeguimiento: "",
        comentario: "",
        // Solo cuando el padre viene del Programa Anual
        seguimientoProgramaID: "",
        avancePrograma: ""
    };

    const cleanErrorStateSemanal = {
        avance: { error: false, helperText: "" },
        fechaSeguimiento: { error: false, helperText: "" },
        personalSeguimiento: { error: false, helperText: "" },
        comentario: { error: false, helperText: "" },
        seguimientoProgramaID: { error: false, helperText: "" },
        avancePrograma: { error: false, helperText: "" }
    };

    const cleanNotificaciones = { mensaje: "", color: null, open: false };

    const [seleccionables, setSeleccionables] = useState({});

    const [stDatos, setState] = useState(cleanState);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [loader, setLoader] = useState(false);
    const [alert, setAlert] = useState(null);
    const [actualizar, setActualizar] = useState(false);
    const [openGenerarPA, setOpenGenerarPA] = useState(false);

    const [stSemanal, setStateSemanal] = useState(cleanStateSemanal);
    const [errorStateSemanal, setErrorStateSemanal] = useState(cleanErrorStateSemanal);
    const [notificacionesSemanal, setNotificacionesSemanal] = useState(cleanNotificaciones);
    const [openSemanal, setOpenSemanal] = useState(false);
    // Origen del padre; si es del Programa Anual el semanal puede ligarse a un seguimiento del programa
    const [stOrigenTipoPadre, setOrigenTipoPadre] = useState("");
    const [stSeguimientosPrograma, setSeguimientosPrograma] = useState([]);
    // Avance actual del padre del programa (el de su tarea): se muestra, sin poder cambiarlo, en el semanal nuevo
    const [stAvancePadre, setAvancePadre] = useState("");
    const esPadreDelPrograma = String(stOrigenTipoPadre || "").trim().toUpperCase() === "PROGRAMA ANUAL";
    const [disabledSemanal, setDisabledSemanal] = useState(false);
    const [loaderSemanal, setLoaderSemanal] = useState(false);
    const [actualizarSemanal, setActualizarSemanal] = useState(false);

    const [openVerSemanal, setOpenVerSemanal] = useState(false);
    const [stSeguimientoSeguroID, setSeguimientoSeguroID] = useState(-1);
    const [stFolio, setFolio] = useState("");
    // Rango programado del padre: se muestra en el semanal y limita la fecha de seguimiento
    const [stFechaInicioPadre, setFechaInicioPadre] = useState("");
    const [stFechaFinalPadre, setFechaFinalPadre] = useState("");
    const [stActuales, setActuales] = useState({ ejercicioID: "", semanaID: "", numSemana: "", estadoID: "" });
    // Tabla toma el defaultValue de sus filtros solo en el primer render, por eso se monta
    // hasta tener calculado el ejercicio vigente
    const [stCatalogosListos, setCatalogosListos] = useState(false);

    const tipoSeguimientoIDRef = useRef(null);
    const empresaIDRef = useRef(null);
    const ramoSeguimientoRef = useRef(null);
    const ejercicioIDRef = useRef(null);
    const estadoIDRef = useRef(null);
    const folioRef = useRef(null);
    const descripcionRef = useRef(null);

    const comentarioRef = useRef(null);

    let titleModal = `${stDatos.seguimientoSeguroID ? "Modificar" : "Agregar"} Pendientes de Seguro`;
    let titleModalSemanal = `${stSemanal.seguimientoSemanalSegID ? "Modificar" : "Agregar"} Seguimiento Semanal`;

    /* ------------------------------------------------------------------ PADRE */

    // Datos del padre que necesita el seguimiento semanal (historial y captura)
    const parametrosPadre = [{ campo: "seguimientoSeguroID" }, { campo: "folio" }, { campo: "fechaIngreso" }, { campo: "fechaSeguimiento" }, { campo: "origenTipo" }];

    function ftContextoPadre({ seguimientoSeguroID, folio, fechaIngreso, fechaSeguimiento, origenTipo }) {
        setSeguimientoSeguroID(seguimientoSeguroID);
        setOrigenTipoPadre(origenTipo || "");
        setFolio(folio);
        setFechaInicioPadre(fechaIngreso ? moment(fechaIngreso) : "");
        setFechaFinalPadre(fechaSeguimiento ? moment(fechaSeguimiento) : "");
    }

    let acciones = [{
        accionID: [1, 3],
        icono: Edit,
        color: info,
        descripcion: "Modificar",
        parametros: [{ campo: "seguimientoSeguroID" }],
        disabled: { multiseleccion: true },
        onClick: (parametros) => handleModificar({
            parametros, token, setState, setOpen, setAlert,
            asyncGet: getSeguimientoSeguros,
            formatearResultado: [
                { id: "fechaIngreso", formato: (data) => data ? moment(data) : "" },
                { id: "personalSeguimiento", formato: (data) => data === null || data === undefined ? "" : data },
                { id: "fechaSeguimiento", formato: (data) => data ? moment(data) : "" },
                { id: "fechaAlta", formato: (data) => data ? moment(data) : "" },
                { id: "inicioVigencia", formato: (data) => data ? moment(data) : "" },
                { id: "finVigencia", formato: (data) => data ? moment(data) : "" },
                { id: "sumaAseg", formato: (data) => data === null || data === undefined ? "" : String(data) },
                { id: "primaNeta", formato: (data) => data === null || data === undefined ? "" : String(data) },
                { id: "primaTotal", formato: (data) => data === null || data === undefined ? "" : String(data) },
                { id: "fechaSolicitud", formato: (data) => data ? moment(data) : "" },
                // Si trae una divisa fuera de MXN / USD (o 0 de registros anteriores) se deja vacía para que la elijan
                { id: "divisaID", formato: (data) => (seleccionables.Divisas || []).some(({ value }) => value !== null && String(value) === String(data)) ? String(data) : "" }
            ]
        })
    }, {
        id: "agregarSemanal",
        accionID: [8],
        icono: PlaylistAddIcon,
        color: success,
        descripcion: "Agregar seguimiento",
        parametros: parametrosPadre,
        disabled: { multiseleccion: true },
        // Abre directo la captura del seguimiento semanal, sin pasar por el historial
        onClick: (parametros) => {
            ftContextoPadre(parametros);
            setOpenSemanal(true);
        }
    }, {
        id: "verSemanal",
        accionID: [8],
        icono: HistoryIcon,
        color: primary,
        descripcion: "Historial de seguimiento",
        parametros: parametrosPadre,
        disabled: { multiseleccion: true },
        onClick: (parametros) => {
            ftContextoPadre(parametros);
            setActualizarSemanal(!actualizarSemanal);
            setOpenVerSemanal(true);
        }
    }, {
        id: "eliminar",
        accionID: [4],
        icono: Close,
        color: danger,
        descripcion: "Eliminar",
        parametros: [{ campo: "seguimientoSeguroID" }, { campo: "folio" }],
        disabled: { multiseleccion: true },
        onClick: ({ seguimientoSeguroID, folio }) => handelAlertEliminar({
            setAlert,
            mensaje: ` el seguimiento ${folio ? folio : ""}`,
            onCancel: () => setAlert(null),
            onConfirm: () => handleEliminar({
                token, setAlert, setActualizar, actualizar,
                parametros: { seguimientoSeguroID }, asyncDelete: deleteSeguimientoSeguros
            })
        })
    }];

    // Último filtro que usó la tabla (sin la paginación), para el Excel
    const refFiltroTabla = useRef({});

    async function ftTablaSeguimientos(variables, token) {
        refFiltroTabla.current = variables && variables.filtro ? variables.filtro : {};
        return tablaSeguimientoSeguros(variables, token);
    }

    async function ftDescargarExcel() {
        setAlert({
            descripcion: "Generando el Excel del seguimiento de seguros",
            title: "Espere...",
            tipo: success,
            showConfirm: false,
            showCancel: false
        });
        try {
            let { pagina, limite, count, ...filtro } = refFiltroTabla.current || {};
            let formdata = new FormData();
            formdata.append("filtro", JSON.stringify(filtro));
            // Encabezado de la última columna: fecha y hora de generación (p. ej. 30/sep/2026 17:00)
            let ahora = moment();
            let meses = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
            formdata.append("fechaHora", `${ahora.format("DD")}/${meses[ahora.month()]}/${ahora.format("YYYY HH:mm")}`);

            let respuesta = await fetch(`${urlServidor}/service/reportes/SeguimientoSegurosExcel`, {
                method: 'POST',
                headers: { token },
                body: formdata
            });
            if (!respuesta.ok) {
                let { mensaje } = await respuesta.json().catch(() => ({}));
                throw new Error(mensaje || "No se pudo generar el Excel");
            }
            let archivo = await respuesta.blob();
            let url = window.URL.createObjectURL(archivo);
            let a = document.createElement('a');
            a.href = url;
            a.download = `Seguimiento Seguros ${moment().format("DD-MM-YYYY")}.xlsx`;
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            setAlert(null);
        } catch ({ message }) {
            setAlert({
                descripcion: `No se pudo generar el Excel: ${NetworkError(message)}`,
                title: "¡Una disculpa!",
                tipo: danger,
                msjConfirmacion: "Aceptar",
                onConfirm: () => setAlert(null),
                showCancel: false
            });
        }
    }

    let botones = [{
        accionID: [2],
        icono: Add,
        color: success,
        descripcion: "Agregar",
        onClick: () => {
            setState(stDatos => ({
                ...stDatos,
                ejercicioID: stActuales.ejercicioID,
                semanaAltaID: stActuales.semanaID,
                estadoID: stActuales.estadoID
            }));
            setOpen(true);
        },
        disabled: { multiseleccion: true }
    }, {
        accionID: [2],
        icono: EventAvailableIcon,
        color: primary,
        descripcion: "Generar desde Programa Anual",
        onClick: () => setOpenGenerarPA(true),
        disabled: { multiseleccion: true }
    }, {
        icono: SyncIcon,
        color: info,
        descripcion: "Actualizar",
        onClick: () => setActualizar(!actualizar),
        disabled: { multiseleccion: true }
    }, {
        icono: RiFileExcel2Fill,
        color: success,
        descripcion: "Excel Seguimiento",
        onClick: () => ftDescargarExcel(),
        disabled: { multiseleccion: true }
    }];

    const infoTabla = {
        botones,
        acciones,
        // Un seguimiento con seguimientos semanales ya no se elimina (cada semanal suma avance mayor a 0)
        accionesEffect: [{ botones: ["eliminar"], ocultar: (fila) => Number(fila && fila.avance ? fila.avance.value : 0) > 0 }],
        actualizar,
        id: "seguimientoSeguroID",
        color: primary,
        title: "Seguimiento Pendientes Seguros",
        iconTable: <PersonPinCircleIcon />,
        headers: [
            { variable: "seguimientoSeguroID", descripcion: "ID", hide: true },
            { variable: "tipoSeguimientoID", descripcion: "tipoSeguimientoID", hide: true },
            { variable: "empresaID", descripcion: "empresaID", hide: true },
            { variable: "ejercicioID", descripcion: "ejercicioID", hide: true },
            { variable: "estadoID", descripcion: "estadoID", hide: true },
            // Color del estado (catálogo de estados); se usa para pintar la columna Estado
            { variable: "estadoColor", descripcion: "estadoColor", hide: true },
            { variable: "responsableID", descripcion: "responsableID", hide: true },
            // Orden del formato de seguimiento que maneja el cliente
            { variable: "responsable", descripcion: "Responsable" },
            { variable: "empresa", descripcion: "Empresa" },
            { variable: "tipoSeguimiento", descripcion: "Tipo" },
            { variable: "ramoSeguimiento", descripcion: "Ramo de Seguro" },
            { variable: "descripcion", descripcion: "Descripción" },
            { variable: "numpolEndoso", descripcion: "Póliza / Endoso" },
            { variable: "inciso", descripcion: "Inciso" },
            { variable: "inicioVigencia", descripcion: "Inicio de Vigencia" },
            { variable: "finVigencia", descripcion: "Fin de Vigencia" },
            { variable: "diasVigencia", descripcion: "Días de Vigencia" },
            { variable: "estado", descripcion: "Estado" },
            { variable: "folio", descripcion: "Folio" },
            { variable: "origenTipo", descripcion: "origenTipo", hide: true },
            { variable: "primaNeta", descripcion: "Prima Neta" },
            { variable: "primaTotal", descripcion: "Prima Total" },
            { variable: "sumaAseg", descripcion: "Suma Asegurada" },
            { variable: "divisaID", descripcion: "divisaID", hide: true },
            { variable: "divisa", descripcion: "Divisa" },
            { variable: "fechaSolicitud", descripcion: "Fecha de Solicitud" },
            { variable: "fechaIngreso", descripcion: "Fecha de Ingreso" },
            { variable: "fechaSeguimiento", descripcion: "Fecha de Seguimiento" },
            { variable: "diasSeguimiento", descripcion: "Días Transcurridos" },
            { variable: "avance", descripcion: "% Avance" },
            { variable: "personalSeguimiento", descripcion: "Personal de Seguimiento" },
            { variable: "ejercicio", descripcion: "Ejercicio" },
            { variable: "numSemanaAlta", descripcion: "Semana Alta" }
        ],
        responsiveTitle: ["folio", "empresa", "estado"],
        filter: [
            { campo: "folio", variable: "folio", placeholder: "Capture el folio" },
            { campo: "numpolEndoso", variable: "numpolEndoso", placeholder: "Capture la póliza" },
            { campo: "descripcion", variable: "descripcion", placeholder: "Capture la descripción" },
            { campo: "ramoSeguimiento", variable: "ramoSeguimiento", placeholder: "Capture el ramo" }
        ],
        selectFilter: [
            {
                campo: "ejercicioID", title: "Ejercicio",
                // Por defecto el ejercicio actual
                retorna: "number", limpiarFiltro: "Todos",
                defaultValue: stActuales.ejercicioID,
                data: seleccionables.Ejercicios ? seleccionables.Ejercicios : [], grid: { md: 3, lg: 3 }
            },
            {
                campo: "tipoSeguimientoID", title: "Tipo",
                retorna: "number", limpiarFiltro: "Todos",
                data: seleccionables.Tipos ? seleccionables.Tipos : [], grid: { md: 3, lg: 3 }
            },
            {
                campo: "empresaID", title: "Empresa",
                retorna: "number", limpiarFiltro: "Todas",
                data: seleccionables.Empresas ? seleccionables.Empresas : [], grid: { md: 3, lg: 3 }
            },
            {
                campo: "estadoID", title: "Estado",
                retorna: "number", limpiarFiltro: "Todos",
                data: seleccionables.Estados ? seleccionables.Estados : [], grid: { md: 3, lg: 3 }
            }
        ],
        formato: [
            { columnas: ["fechaIngreso", "fechaSeguimiento", "fechaAlta", "inicioVigencia", "finVigencia", "fechaSolicitud"], tipo: "fecha", onlyDate: true },
            // Se formatean aparte para que el 0 se vea (la tabla deja vacío un valor 0)
            { columnas: ["avance"], tipo: "custom", callback: (valor) => valor === null || valor === undefined || valor === "" ? "" : `${Number(valor)}%` },
            { columnas: ["diasSeguimiento", "diasVigencia"], tipo: "custom", callback: (valor) => valor === null || valor === undefined || valor === "" ? "" : String(valor) },
            { columnas: ["primaNeta", "primaTotal", "sumaAseg"], tipo: "moneda" },
            // La descripción suele ser larga: se le da más ancho para que no se amontone en pocas palabras por renglón
            { columnas: ["descripcion"], tipo: "custom", callback: (valor) => <div style={{ minWidth: "320px" }}>{valor}</div> },
            // El estado se pinta con el color que tiene en su catálogo; sin color se deja normal
            { columnas: ["estado"], tipo: "custom", callback: (valor, row) => ftCeldaEstado(valor, row && row.estadoColor ? row.estadoColor.value : "") }
        ],
        alineacion: [{ columnas: [0, 1, 2, 3, 4], alineacion: "left" }]
    };

    const inputs = [
        {
            disabled,
            id: "responsableID",
            value: stDatos.responsableID,
            error: errorState.responsableID.error,
            success: stDatos.responsableID && !errorState.responsableID.error ? true : undefined,
            helperText: errorState.responsableID.helperText,
            title: "Responsable",
            placeholder: "Seleccione el responsable",
            tipo: "select",
            data: seleccionables.Responsables ? seleccionables.Responsables : [],
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "responsableID")
        },
        {
            disabled,
            id: "empresaID",
            value: stDatos.empresaID,
            error: errorState.empresaID.error,
            success: stDatos.empresaID && !errorState.empresaID.error ? true : undefined,
            helperText: errorState.empresaID.helperText,
            inputRef: empresaIDRef,
            title: "Empresa *",
            placeholder: "Seleccione la empresa",
            tipo: "select",
            data: seleccionables.Empresas ? seleccionables.Empresas : [],
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "empresaID")
        },
        {
            disabled,
            id: "tipoSeguimientoID",
            value: stDatos.tipoSeguimientoID,
            error: errorState.tipoSeguimientoID.error,
            success: stDatos.tipoSeguimientoID && !errorState.tipoSeguimientoID.error ? true : undefined,
            helperText: errorState.tipoSeguimientoID.helperText,
            inputRef: tipoSeguimientoIDRef,
            title: "Categoría Seguimiento *",
            placeholder: "Categoría Seguimiento *",
            tipo: "select",
            data: seleccionables.Tipos ? seleccionables.Tipos : [],
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "tipoSeguimientoID")
        },
        {
            disabled:false,
            id: "estadoID",
            value: stDatos.estadoID,
            error: errorState.estadoID.error,
            success: stDatos.estadoID && !errorState.estadoID.error ? true : undefined,
            helperText: errorState.estadoID.helperText,
            inputRef: estadoIDRef,
            title: "Estado Seguimiento *",
            placeholder: "Seleccione el estado",
            tipo: "select",
            data: seleccionables.Estados ? seleccionables.Estados : [],
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "estadoID")
        },        
        {
            disabled,
            id: "descripcion",
            multiline: true,
            value: stDatos.descripcion,
            error: errorState.descripcion.error,
            success: stDatos.descripcion && !errorState.descripcion.error ? true : undefined,
            helperText: errorState.descripcion.helperText,
            inputRef: descripcionRef,
            title: "Descripción *",
            placeholder: "Capture la descripción del seguimiento",
            grid: { md: 9, lg: 9 },
            onChange: ({ target: { value } }) => handleChange(value, "descripcion"),
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "ramoSeguimiento",
            value: stDatos.ramoSeguimiento,
            error: errorState.ramoSeguimiento.error,
            success: stDatos.ramoSeguimiento && !errorState.ramoSeguimiento.error ? true : undefined,
            helperText: errorState.ramoSeguimiento.helperText,
            inputRef: ramoSeguimientoRef,
            title: "Ramo de Seguro *",
            placeholder: "Capture el ramo de seguro",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "ramoSeguimiento"),
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "numpolEndoso",
            value: stDatos.numpolEndoso,
            error: errorState.numpolEndoso.error,
            success: stDatos.numpolEndoso && !errorState.numpolEndoso.error ? true : undefined,
            helperText: errorState.numpolEndoso.helperText,
            title: "Póliza",
            placeholder: "Capture la póliza",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "numpolEndoso"),
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "inciso",
            value: stDatos.inciso,
            error: errorState.inciso.error,
            success: stDatos.inciso && !errorState.inciso.error ? true : undefined,
            helperText: errorState.inciso.helperText,
            title: "Inciso",
            placeholder: "Capture el inciso",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "inciso"),
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "primaNeta",
            value: stDatos.primaNeta,
            error: errorState.primaNeta.error,
            success: stDatos.primaNeta && !errorState.primaNeta.error ? true : undefined,
            helperText: errorState.primaNeta.helperText,
            title: "Prima Neta $",
            placeholder: "0.00",
            textAlign: "right",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => { (!isNaN(Number(value)) || value === "") && handleChange(value, "primaNeta") },
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "primaTotal",
            value: stDatos.primaTotal,
            error: errorState.primaTotal.error,
            success: stDatos.primaTotal && !errorState.primaTotal.error ? true : undefined,
            helperText: errorState.primaTotal.helperText,
            title: "Prima Total $",
            placeholder: "0.00",
            textAlign: "right",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => { (!isNaN(Number(value)) || value === "") && handleChange(value, "primaTotal") },
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "sumaAseg",
            value: stDatos.sumaAseg,
            error: errorState.sumaAseg.error,
            success: stDatos.sumaAseg && !errorState.sumaAseg.error ? true : undefined,
            helperText: errorState.sumaAseg.helperText,
            title: "Suma Asegurada $",
            placeholder: "0.00",
            textAlign: "right",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => { (!isNaN(Number(value)) || value === "") && handleChange(value, "sumaAseg") },
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "inicioVigencia",
            value: stDatos.inicioVigencia,
            error: errorState.inicioVigencia.error,
            success: stDatos.inicioVigencia && !errorState.inicioVigencia.error ? true : undefined,
            helperText: errorState.inicioVigencia.helperText,
            title: "Inicio de Vigencia",
            placeholder: "Inicio de vigencia",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 3, lg: 3 },
            onChange: (value) => { if (typeof value !== "object") return; handleChange(value, "inicioVigencia") }
        },
        {
            disabled,
            id: "finVigencia",
            value: stDatos.finVigencia,
            error: errorState.finVigencia.error,
            success: stDatos.finVigencia && !errorState.finVigencia.error ? true : undefined,
            helperText: errorState.finVigencia.helperText,
            title: "Fin de Vigencia",
            placeholder: "Fin de vigencia",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 3, lg: 3 },
            onChange: (value) => { if (typeof value !== "object") return; handleChange(value, "finVigencia") }
        },
        {
            disabled: true,
            id: "diasVigencia",
            value: ftDiasVigencia(stDatos.inicioVigencia, stDatos.finVigencia),
            title: "Días de Vigencia",
            placeholder: "Se calcula de la vigencia",
            grid: { md: 3, lg: 3 },
            onChange: () => { return; }
        },
        {
            disabled: false,
            id: "fechaSolicitud",
            value: stDatos.fechaSolicitud,
            title: "Fecha de Solicitud",
            placeholder: "Fecha de Solicitud",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 3, lg: 3 },
            onChange: () => { return; }
        },
        {
            disabled,
            id: "divisaID",
            value: stDatos.divisaID,
            error: errorState.divisaID.error,
            success: stDatos.divisaID && !errorState.divisaID.error ? true : undefined,
            helperText: errorState.divisaID.helperText,
            title: "Divisa *",
            placeholder: "Seleccione la divisa",
            tipo: "select",
            data: seleccionables.Divisas ? seleccionables.Divisas : [],
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "divisaID")
        },
        {
            disabled,
            id: "fechaIngreso",
            value: stDatos.fechaIngreso,
            error: errorState.fechaIngreso.error,
            success: stDatos.fechaIngreso && !errorState.fechaIngreso.error ? true : undefined,
            helperText: errorState.fechaIngreso.helperText,
            title: "Fecha de Ingreso *",
            placeholder: "Fecha de Ingreso *",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 3, lg: 3 },
            onChange: (value) => { if (typeof value !== "object") return; handleChange(value, "fechaIngreso") }
        },
        {
            // No se modifica a mano: la actualiza cada seguimiento semanal que se da de alta
            disabled: true,
            id: "fechaSeguimiento",
            value: stDatos.fechaSeguimiento,
            error: errorState.fechaSeguimiento.error,
            success: stDatos.fechaSeguimiento && !errorState.fechaSeguimiento.error ? true : undefined,
            helperText: errorState.fechaSeguimiento.helperText,
            title: "Fecha Ultimo Seguimiento",
            placeholder: "Fecha Ultimo Seguimiento",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 3, lg: 3 },
            onChange: (value) => { if (typeof value !== "object") return; handleChange(value, "fechaSeguimiento") }
        },
        {
            disabled,
            id: "personalSeguimiento",
            value: stDatos.personalSeguimiento,
            error: errorState.personalSeguimiento.error,
            success: stDatos.personalSeguimiento && !errorState.personalSeguimiento.error ? true : undefined,
            helperText: errorState.personalSeguimiento.helperText,
            title: "Personal de Seguimiento",
            placeholder: "Capture quién da el seguimiento",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "personalSeguimiento"),
            onKeyDown: () => { return; }
        },
        {
            disabled,
            id: "folio",
            value: stDatos.folio,
            error: errorState.folio.error,
            success: stDatos.folio && !errorState.folio.error ? true : undefined,
            helperText: errorState.folio.helperText,
            inputRef: folioRef,
            title: "Folio",
            placeholder: "Capture el folio",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "folio"),
            onKeyDown: () => { return; }
        },
        {
            disabled: true,
            id: "origenTipo",
            value: stDatos.origenTipo,
            error: errorState.origenTipo.error,
            success: stDatos.origenTipo && !errorState.origenTipo.error ? true : undefined,
            helperText: errorState.origenTipo.helperText,
            title: "Origen",
            placeholder: "Origen",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => handleChange(value, "origenTipo"),
            onKeyDown: () => { return; }
        },        
        {
            disabled: true,
            id: "avance",
            value: stDatos.avance,
            error: errorState.avance.error,
            success: stDatos.avance && !errorState.avance.error ? true : undefined,
            helperText: errorState.avance.helperText,
            title: "% Avance",
            placeholder: "0.00",
            textAlign: "right",
            grid: { md: 3, lg: 3 },
            onChange: ({ target: { value } }) => { (!isNaN(Number(value)) || value === "") && handleChange(value, "avance") },
            onKeyDown: () => { return; }
        },
    ];

    let accionesFormulario = [{
        accionID: stDatos.seguimientoSeguroID ? [3] : [2],
        loader,
        disabled,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => handleGuardar({
            setLoader,
            setDisabled,
            setActualizar,
            actualizar,
            setNotificaciones,
            handleClose,
            handleFocus,
            refFocus: empresaIDRef,
            mensajeCorrecto: `El seguimiento se ${stDatos.seguimientoSeguroID ? "actualizó" : "agregó"} correctamente`,
            asyncCallback: ftGuardar
        })
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleClose
    }];

    /* ------------------------------------------------------------------- HIJA */

    const accionesSemanal = [{
        icono: Edit,
        color: info,
        descripcion: "Modificar",
        parametros: [{ campo: "seguimientoSemanalSegID" }],
        disabled: { multiseleccion: true },
        onClick: (parametros) => handleModificar({
            parametros, token, setState: setStateSemanal, setOpen: setOpenSemanal, setAlert,
            asyncGet: getSeguimientoSemanalSeg,
            formatearResultado: [
                { id: "fechaSeguimiento", formato: (data) => data ? moment(data) : "" },
                { id: "comentario", formato: (data) => data === null ? "" : data },
                { id: "personalSeguimiento", formato: (data) => data === null ? "" : data },
                { id: "seguimientoProgramaID", formato: (data) => data === null || data === undefined ? "" : String(data) },
                { id: "avancePrograma", formato: (data) => data === null || data === undefined ? "" : String(Number(data)) },
                // El autocomplete del % compara contra el texto de sus opciones
                { id: "avance", formato: (data) => data === null || data === undefined ? "" : String(Number(data)) }
            ]
        })
    }, {
        icono: Close,
        color: danger,
        descripcion: "Eliminar",
        parametros: [{ campo: "seguimientoSemanalSegID" }, { campo: "numSemana" }],
        disabled: { multiseleccion: true },
        onClick: ({ seguimientoSemanalSegID, numSemana }) => handelAlertEliminar({
            setAlert,
            mensaje: ` el seguimiento de la semana ${numSemana}`,
            onCancel: () => setAlert(null),
            onConfirm: () => handleEliminar({
                token, setAlert, setActualizar: setActualizarSemanal, actualizar: actualizarSemanal,
                parametros: { seguimientoSemanalSegID }, asyncDelete: deleteSeguimientoSemanalSeg
            })
        })
    }];

    const botonesSemanal = [{
        icono: SyncIcon,
        color: info,
        descripcion: "Actualizar",
        onClick: () => setActualizarSemanal(!actualizarSemanal),
        disabled: { multiseleccion: true }
    }];

    useEffect(() => {
        async function ftEffect() {
            if (!esPadreDelPrograma || !(Number(stSeguimientoSeguroID) > 0) || !(openSemanal || openVerSemanal)) {
                setAvancePadre("");
                return setSeguimientosPrograma([]);
            }
            try {
                setSeguimientosPrograma(await seleccionSeguimientosPrograma(Number(stSeguimientoSeguroID), token));
            } catch (e) {
                setSeguimientosPrograma([]);
            }
            try {
                let padre = await getSeguimientoSeguros({ seguimientoSeguroID: Number(stSeguimientoSeguroID) }, token);
                setAvancePadre(padre && padre.avance !== null && padre.avance !== undefined ? String(Number(padre.avance)) : "");
            } catch (e) {
                setAvancePadre("");
            }
        } ftEffect();
    }, [stSeguimientoSeguroID, stOrigenTipoPadre, openSemanal, openVerSemanal]);

    const infoTablaSemanal = {
        botones: botonesSemanal,
        acciones: accionesSemanal,
        actualizar: actualizarSemanal,
        id: "seguimientoSemanalSegID",
        color: primary,
        title: `Seguimiento Semanal ${stFolio ? "(" + stFolio + ")" : ""}`,
        iconTable: <EventNoteIcon />,
        headers: [
            { variable: "seguimientoSemanalSegID", descripcion: "ID", hide: true },
            { variable: "seguimientoSeguroID", descripcion: "seguimientoSeguroID", hide: true },
            // Si el padre viene del programa es el avance que tenía el padre (su tarea) al guardar el semanal
            { variable: "avance", descripcion: "% Avance" },
            { variable: "comentario", descripcion: "Comentario" },
            { variable: "seguimientoPrograma", descripcion: "Seguimiento del Programa", hide: !esPadreDelPrograma },
            { variable: "avancePrograma", descripcion: "% Avance del Programa", hide: !esPadreDelPrograma },
            { variable: "fechaSeguimiento", descripcion: "Fecha Seguimiento" },
            { variable: "personalSeguimiento", descripcion: "Personal" },
            { variable: "usuario", descripcion: "Capturó" },
            { variable: "altaSeguimiento", descripcion: "Alta del Seguimiento" }
        ],
        responsiveTitle: ["fechaSeguimiento", "comentario"],
        formato: [
            { columnas: ["fechaSeguimiento"], tipo: "fecha", onlyDate: true },
            { columnas: ["altaSeguimiento"], tipo: "fecha" },
            { columnas: ["avance", "avancePrograma"], tipo: "porcentaje", simbolo: "%" }
        ],
        alineacion: [{ columnas: [0, 1, 2], alineacion: "left" }]
    };

    const inputsSemanal = [
        {
            disabled: true,
            id: "fechaInicioPadre",
            value: stFechaInicioPadre,
            title: "Fecha de Ingreso",
            placeholder: "Fecha de ingreso",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 4, lg: 4 },
            onChange: () => { return; }
        },
        {
            disabled: true,
            id: "fechaFinalPadre",
            value: stFechaFinalPadre,
            title: "Último Seguimiento",
            placeholder: "Último Seguimiento",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 4, lg: 4 },
            onChange: () => { return; }
        },
        {
            disabled: disabledSemanal,
            id: "fechaSeguimiento",
            value: stSemanal.fechaSeguimiento,
            error: errorStateSemanal.fechaSeguimiento.error,
            success: stSemanal.fechaSeguimiento && !errorStateSemanal.fechaSeguimiento.error ? true : undefined,
            helperText: errorStateSemanal.fechaSeguimiento.helperText,
            title: "Fecha de Seguimiento *",
            placeholder: "Fecha de seguimiento",
            tipo: "datetimepicker",
            onlyDate: true,
            timeFormat: false,
            grid: { md: 4, lg: 4 },
            onChange: (value) => { if (typeof value !== "object") return; handleChangeSemanal(value, "fechaSeguimiento") }
        },
        {
            disabled: disabledSemanal,
            id: "comentario",
            multiline: true,
            value: stSemanal.comentario,
            error: errorStateSemanal.comentario.error,
            success: stSemanal.comentario && !errorStateSemanal.comentario.error ? true : undefined,
            helperText: errorStateSemanal.comentario.helperText,
            inputRef: comentarioRef,
            title: "Comentario *",
            placeholder: "Capture el comentario del seguimiento",
            grid: { md: 12, lg: 12 },
            onChange: ({ target: { value } }) => handleChangeSemanal(value, "comentario"),
            onKeyDown: () => { return; }
        },
        // Padre que viene del Programa Anual: se elige un seguimiento de las actividades de su tarea
        {
            hidden: !esPadreDelPrograma,
            disabled: disabledSemanal,
            id: "seguimientoProgramaID",
            value: stSemanal.seguimientoProgramaID,
            error: errorStateSemanal.seguimientoProgramaID.error,
            helperText: errorStateSemanal.seguimientoProgramaID.helperText,
            title: "Seguimiento del Programa *",
            placeholder: stSeguimientosPrograma.length > 0 ? "Seleccione el seguimiento del programa" : "La tarea no tiene seguimientos",
            tipo: "autocomplete",
            data: stSeguimientosPrograma,
            grid: { md: 8, lg: 8 },
            onChange: (opcion) => handleChangeSemanal(opcion && opcion.value ? String(opcion.value) : "", "seguimientoProgramaID")
        },
        {
            // % que este semanal le avanza al seguimiento del programa elegido; se suma en el % Avance
            // del seguimiento de la actividad
            hidden: !esPadreDelPrograma,
            disabled: disabledSemanal,
            id: "avancePrograma",
            value: stSemanal.avancePrograma,
            error: errorStateSemanal.avancePrograma.error,
            success: stSemanal.avancePrograma && !errorStateSemanal.avancePrograma.error ? true : undefined,
            helperText: errorStateSemanal.avancePrograma.helperText,
            title: "% Avance del Programa *",
            placeholder: "Capture el %",
            grid: { md: 4, lg: 4 },
            onChange: ({ target: { value } }) => { (value === "" || !isNaN(Number(value))) && handleChangeSemanal(value, "avancePrograma") }
        },
        {
            disabled: disabledSemanal,
            id: "personalSeguimiento",
            value: stSemanal.personalSeguimiento,
            error: errorStateSemanal.personalSeguimiento.error,
            success: stSemanal.personalSeguimiento && !errorStateSemanal.personalSeguimiento.error ? true : undefined,
            helperText: errorStateSemanal.personalSeguimiento.helperText,
            title: "Personal que dio Seguimiento",
            placeholder: "Capture el nombre del personal",
            grid: { md: 8, lg: 8 },
            onChange: ({ target: { value } }) => handleChangeSemanal(value, "personalSeguimiento"),
            onKeyDown: () => { return; }
        },
        {
            hidden: esPadreDelPrograma,
            disabled: disabledSemanal,
            id: "avance",
            value: stSemanal.avance,
            error: errorStateSemanal.avance.error,
            success: stSemanal.avance && !errorStateSemanal.avance.error ? true : undefined,
            helperText: errorStateSemanal.avance.helperText,
            title: "% Avance *",
            placeholder: "Seleccione o escriba el %",
            // Se elige de 5 en 5 hasta 100, o se escribe otro valor (Enter para tomarlo)
            tipo: "autocomplete",
            addNewValue: true,
            data: ftOpcionesAvance(),
            grid: { md: 4, lg: 4 },
            onChange: (opcion) => {
                let valor = opcion && opcion.value !== null && opcion.value !== undefined ? String(opcion.value).replace("%", "").trim() : "";
                if (valor === "" || !isNaN(Number(valor))) handleChangeSemanal(valor, "avance");
            }
        },
        {
            // Padre del programa: el avance es el de su tarea y no se captura. En uno nuevo se ve el actual;
            // al modificar, el que tenía el padre cuando se guardó el semanal
            hidden: !esPadreDelPrograma,
            disabled: true,
            id: "avanceTarea",
            value: stSemanal.seguimientoSemanalSegID ? stSemanal.avance : stAvancePadre,
            title: "% Avance",
            grid: { md: 4, lg: 4 },
            onChange: () => { return; }
        },
    ];

    const accionesFormularioSemanal = [{
        loader: loaderSemanal,
        disabled: disabledSemanal,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => handleGuardar({
            setLoader: setLoaderSemanal,
            setDisabled: setDisabledSemanal,
            setActualizar: setActualizarSemanal,
            actualizar: actualizarSemanal,
            setNotificaciones: setNotificacionesSemanal,
            handleClose: handleCloseSemanal,
            handleFocus,
            refFocus: comentarioRef,
            mensajeCorrecto: `El seguimiento semanal se ${stSemanal.seguimientoSemanalSegID ? "actualizó" : "agregó"} correctamente`,
            asyncCallback: ftGuardarSemanal
        })
    }, {
        disabled: disabledSemanal,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleCloseSemanal
    }];

    /* --------------------------------------------------------------- METODOS */

    function ftVigentesALaFecha(Ejercicios = [], Semanas = []) {
        let hoy = moment();
        let vigente = ({ fechaInicio, fechaFin }) => fechaInicio && fechaFin &&
            hoy.isBetween(moment(fechaInicio), moment(fechaFin), 'day', '[]');

        let ejercicio = Ejercicios.find(vigente);
        let semanas = ejercicio
            ? Semanas.filter(({ ejercicioID }) => Number(ejercicioID) === Number(ejercicio.value))
            : Semanas;
        let semana = semanas.find(vigente);

        // Las semanas van de lunes a sábado, así que en domingo ninguna resulta vigente; en ese caso
        // se toma la última semana que ya terminó para no dejar el seguimiento sin semana.
        if (!semana && ejercicio) {
            semana = semanas
                .filter(({ fechaFin }) => fechaFin && moment(fechaFin).isSameOrBefore(hoy, 'day'))
                .reduce((anterior, actual) => !anterior || moment(actual.fechaFin).isAfter(moment(anterior.fechaFin))
                    ? actual
                    : anterior, null);
        }

        return {
            ejercicioID: ejercicio ? ejercicio.value : "",
            semanaID: semana ? semana.value : "",
            numSemana: semana ? semana.numSemana : ""
        };
    }

    function semanasDelEjercicio(ejercicioID) {
        let semanas = seleccionables.Semanas ? seleccionables.Semanas : [];
        // Cuando la consulta del catálogo falla regresa una sola opción con el mensaje de error y sin
        // ejercicioID; se deja pasar para que el mensaje se vea en lugar de una lista vacía.
        if (!ejercicioID || semanas.some(({ value }) => value === null)) return semanas;
        return semanas.filter(({ ejercicioID: ejercicioSemana }) => Number(ejercicioSemana) === Number(ejercicioID));
    }

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState, condicion, ref, keyError, mensajeError,
            loader: setLoader, disabled: setDisabled, errorState: setErrorState
        });
    }

    function ftErrorInputTextSemanal({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState: cleanErrorStateSemanal, condicion, ref, keyError, mensajeError,
            loader: setLoaderSemanal, disabled: setDisabledSemanal, errorState: setErrorStateSemanal
        });
    }

    function handleChange(value, key) {
        setState(stDatos => ({ ...stDatos, [key]: value }));
        setErrorState(errorState => ({ ...errorState, [key]: { error: false, helperText: "" } }));
    }

    function handleChangeSemanal(value, key) {
        setStateSemanal(stSemanal => ({ ...stSemanal, [key]: value }));
        setErrorStateSemanal(errorStateSemanal => ({ ...errorStateSemanal, [key]: { error: false, helperText: "" } }));
    }

    function handleValidaciones({ personalSeguimiento, tipoSeguimientoID, empresaID, ramoSeguimiento, ejercicioID, estadoID, descripcion, fechaIngreso, inicioVigencia, finVigencia, divisaID, sumaAseg, primaNeta, primaTotal }) {
        let error;
        let validaciones = [
            {
                condicion: !tipoSeguimientoID,
                ref: tipoSeguimientoIDRef, keyError: "tipoSeguimientoID",
                mensajeError: "Debe especificar el tipo de seguimiento"
            },
            {
                condicion: !empresaID,
                ref: empresaIDRef, keyError: "empresaID",
                mensajeError: "Debe especificar la empresa"
            },
            {
                condicion: !ramoSeguimiento || trim(ramoSeguimiento) === "",
                ref: ramoSeguimientoRef, keyError: "ramoSeguimiento",
                mensajeError: "Debe especificar el ramo de seguro"
            },
            {
                condicion: trim(personalSeguimiento || "").length > 100,
                ref: null, keyError: "personalSeguimiento",
                mensajeError: "El personal de seguimiento no debe exceder de 100 caracteres"
            },
            {
                condicion: trim(ramoSeguimiento || "").length > 100,
                ref: ramoSeguimientoRef, keyError: "ramoSeguimiento",
                mensajeError: "El ramo no debe exceder de 100 caracteres"
            },
            {
                condicion: !ejercicioID,
                ref: ejercicioIDRef, keyError: "ejercicioID",
                mensajeError: "Debe especificar el ejercicio"
            },
            {
                condicion: !estadoID,
                ref: estadoIDRef, keyError: "estadoID",
                mensajeError: "Debe especificar el estado"
            },
            {
                condicion: !descripcion || descripcion.trim() === "",
                ref: descripcionRef, keyError: "descripcion",
                mensajeError: "Debe especificar la descripción"
            },
            {
                condicion: !fechaIngreso || !moment(fechaIngreso).isValid(),
                ref: null, keyError: "fechaIngreso",
                mensajeError: "Debe especificar la fecha de ingreso"
            },
            {
                // La vigencia es opcional; si se capturan ambas fechas el fin no puede ser menor al inicio
                condicion: Boolean(inicioVigencia && finVigencia) && moment(finVigencia).isBefore(moment(inicioVigencia), 'day'),
                ref: null, keyError: "finVigencia",
                mensajeError: "El fin de vigencia no puede ser menor al inicio de vigencia"
            },
            {
                condicion: sumaAseg !== "" && sumaAseg !== null && sumaAseg !== undefined && (isNaN(Number(sumaAseg)) || Number(sumaAseg) < 0),
                ref: null, keyError: "sumaAseg",
                mensajeError: "La suma asegurada debe ser un importe mayor o igual a 0"
            },
            {
                condicion: primaNeta !== "" && primaNeta !== null && primaNeta !== undefined && (isNaN(Number(primaNeta)) || Number(primaNeta) < 0),
                ref: null, keyError: "primaNeta",
                mensajeError: "La prima neta debe ser un importe mayor o igual a 0"
            },
            {
                condicion: primaTotal !== "" && primaTotal !== null && primaTotal !== undefined && (isNaN(Number(primaTotal)) || Number(primaTotal) < 0),
                ref: null, keyError: "primaTotal",
                mensajeError: "La prima total debe ser un importe mayor o igual a 0"
            },
            {
                condicion: !divisaID || Number(divisaID) === 0,
                ref: null, keyError: "divisaID",
                mensajeError: "Debe especificar la divisa"
            }
        ];

        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
        });

        if (error) return error;
    }

    function handleValidacionesSemanal({ avance, avanceRestante, fechaSeguimiento, comentario, seguimientoProgramaID, avancePrograma, avanceProgramaRestante }) {
        let error;
        // El seguimiento solo se puede capturar dentro del rango programado del padre
        // Solo no puede ser anterior a la fecha de ingreso: al dar de alta, esta fecha pasa a ser
        // la fecha de seguimiento del padre, por eso no tiene tope
        let fueraDeRango = !fechaSeguimiento || !moment(fechaSeguimiento).isValid() || !stFechaInicioPadre
            || moment(fechaSeguimiento).isBefore(moment(stFechaInicioPadre), 'day');
        let porcentaje = avance === "" || avance === null || avance === undefined ? NaN : Number(avance);
        let porcentajePrograma = avancePrograma === "" || avancePrograma === null || avancePrograma === undefined ? NaN : Number(avancePrograma);
        let validaciones = [
            {
                condicion: fueraDeRango,
                ref: null, keyError: "fechaSeguimiento",
                mensajeError: stFechaInicioPadre
                    ? `La fecha de seguimiento no puede ser anterior a la fecha de ingreso (${moment(stFechaInicioPadre).format("DD/MM/YYYY")})`
                    : "El seguimiento no tiene fecha de ingreso"
            },
            // Padre que no viene del programa: el avance normal suma al del padre
            {
                condicion: !esPadreDelPrograma && (isNaN(porcentaje) || porcentaje <= 0),
                ref: null, keyError: "avance",
                mensajeError: "El porcentaje de avance debe ser mayor a 0"
            },
            {
                condicion: !esPadreDelPrograma && porcentaje > avanceRestante,
                ref: null, keyError: "avance",
                mensajeError: `El porcentaje de avance no puede ser mayor al restante del seguimiento (${avanceRestante}%)`
            },
            {
                condicion: !comentario || comentario.trim() === "",
                ref: comentarioRef, keyError: "comentario",
                mensajeError: "Debe especificar el comentario"
            },
            // Padre del programa: se elige el seguimiento del programa y se captura cuánto le avanza
            {
                condicion: esPadreDelPrograma && !seguimientoProgramaID,
                ref: null, keyError: "seguimientoProgramaID",
                mensajeError: "Debe seleccionar el seguimiento del programa"
            },
            {
                condicion: esPadreDelPrograma && (isNaN(porcentajePrograma) || porcentajePrograma <= 0),
                ref: null, keyError: "avancePrograma",
                mensajeError: "El porcentaje de avance del programa debe ser mayor a 0"
            },
            {
                condicion: esPadreDelPrograma && porcentajePrograma > avanceProgramaRestante,
                ref: null, keyError: "avancePrograma",
                mensajeError: `El porcentaje de avance del programa no puede ser mayor al restante del seguimiento del programa (${avanceProgramaRestante}%)`
            }
        ];

        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputTextSemanal({ condicion, ref, keyError, mensajeError });
        });

        if (error) return error;
    }

    function ftGuardar() {
        async function ftGuardar() {
            let {
                seguimientoSeguroID, tipoSeguimientoID, empresaID, ramoSeguimiento, ejercicioID, semanaAltaID, estadoID,
                personalSeguimiento, responsableID, usuarioID, folio, numpolEndoso, inciso, descripcion,
                fechaIngreso, fechaSeguimiento, fechaAlta, avance, origenID,
                inicioVigencia, finVigencia, divisaID, sumaAseg, primaNeta, primaTotal
            } = stDatos;

            let error = await handleValidaciones({ personalSeguimiento, tipoSeguimientoID, empresaID, ramoSeguimiento, ejercicioID, estadoID, descripcion, fechaIngreso, inicioVigencia, finVigencia, divisaID, sumaAseg, primaNeta, primaTotal });
            if (error) return error;

            let input = {
                tipoSeguimientoID: parseInt(tipoSeguimientoID),
                empresaID: parseInt(empresaID),
                ramoSeguimiento: trim(ramoSeguimiento || ""),
                ejercicioID: parseInt(ejercicioID),
                semanaAltaID: semanaAltaID ? parseInt(semanaAltaID) : null,
                estadoID: parseInt(estadoID),
                personalSeguimiento: trim(personalSeguimiento || "") || null,
                responsableID: responsableID ? parseInt(responsableID) : null,
                usuarioID: usuarioID ? parseInt(usuarioID) : null,
                folio: trim(folio || ""),
                numpolEndoso: trim(numpolEndoso || ""),
                inciso: trim(inciso || ""),
                descripcion: trim(descripcion || ""),
                fechaIngreso: formatearFecha(fechaIngreso),
                // Al dar de alta todavía no hay seguimientos: se guarda igual a la fecha de ingreso
                fechaSeguimiento: formatearFecha(fechaSeguimiento) || formatearFecha(fechaIngreso),
                fechaAlta: formatearFecha(fechaAlta),
                inicioVigencia: formatearFecha(inicioVigencia),
                finVigencia: formatearFecha(finVigencia),
                divisaID: divisaID ? parseInt(divisaID) : null,
                sumaAseg: formatearImporte(sumaAseg),
                primaNeta: formatearImporte(primaNeta),
                primaTotal: formatearImporte(primaTotal),
                avance: avance === "" ? 0 : parseFloat(avance),
                // Se conserva el que ya tenga el registro al modificarlo
                origenID: origenID ? parseInt(origenID) : null
                // origenTipo no se envía: solo lo pone el alta desde solicitud
            };

            if (seguimientoSeguroID) {
                await updateSeguimientoSeguros({ input: { ...input, seguimientoSeguroID } }, token);
            } else {
                await addSeguimientoSeguros({ input }, token);
            }
        }
        return ftGuardar();
    }

    function ftGuardarSemanal() {
        async function ftGuardarSemanal() {
            let {
                seguimientoSemanalSegID, avance,
                fechaSeguimiento, personalSeguimiento, comentario,
                seguimientoProgramaID, avancePrograma
            } = stSemanal;

            // Cada seguimiento suma al avance del padre; al modificar no cuenta lo que ya tenía capturado
            let semanales = await getAllSeguimientoSemanalSeg({ filtro: { seguimientoSeguroID: Number(stSeguimientoSeguroID) } }, token);
            let avanceOtros = (Array.isArray(semanales) ? semanales : [])
                .filter(({ seguimientoSemanalSegID: id }) => String(id) !== String(seguimientoSemanalSegID))
                .reduce((total, { avance: avanceSemanal }) => total + (Number(avanceSemanal) || 0), 0);
            let avanceRestante = Math.max(0, Math.round((100 - avanceOtros) * 100) / 100);

            // Lo que ya le avanzaron al seguimiento del programa los otros semanales (el SP valida contra todos)
            let conPrograma = esPadreDelPrograma && seguimientoProgramaID;
            let avanceProgramaOtros = (Array.isArray(semanales) ? semanales : [])
                .filter(({ seguimientoSemanalSegID: id, seguimientoProgramaID: programaID }) =>
                    String(id) !== String(seguimientoSemanalSegID) && String(programaID) === String(seguimientoProgramaID))
                .reduce((total, { avancePrograma: avanceSemanal }) => total + (Number(avanceSemanal) || 0), 0);
            let avanceProgramaRestante = Math.max(0, Math.round((100 - avanceProgramaOtros) * 100) / 100);

            let error = await handleValidacionesSemanal({
                avance, avanceRestante, fechaSeguimiento, comentario,
                seguimientoProgramaID, avancePrograma, avanceProgramaRestante
            });
            if (error) return error;

            let input = {
                seguimientoSeguroID: parseInt(stSeguimientoSeguroID),
                // Con padre del programa el avance normal no aplica (el del padre es el de la tarea)
                avance: esPadreDelPrograma || avance === "" ? 0 : parseFloat(avance),
                fechaSeguimiento: formatearFecha(fechaSeguimiento),
                personalSeguimiento: trim(personalSeguimiento || ""),
                comentario: trim(comentario || ""),
                seguimientoProgramaID: conPrograma ? Number(seguimientoProgramaID) : null,
                avancePrograma: conPrograma && avancePrograma !== "" ? parseFloat(avancePrograma) : null
            };

            if (seguimientoSemanalSegID) {
                await updateSeguimientoSemanalSeg({ input: { ...input, seguimientoSemanalSegID } }, token);
            } else {
                await addSeguimientoSemanalSeg({ input }, token);
            }

            setActualizar(!actualizar);
        }
        return ftGuardarSemanal();
    }


    // Solo se trabaja con moneda nacional y dólares, aunque el catálogo tenga más divisas activas
    async function ftDivisasPermitidas() {
        const permitidas = ["MXN", "USD"];
        try {
            let divisas = await getAllDivisa({ filtro: {} }, token);
            if (!Array.isArray(divisas)) throw new Error("No se encontraron divisas");
            let opciones = permitidas.map(codigo => {
                let divisa = divisas.find(({ codigoMon, abreviacion }) =>
                    [codigoMon, abreviacion].some(c => String(c || "").trim().toUpperCase() === codigo));
                return divisa ? { value: String(divisa.divisaID), label: codigo } : null;
            }).filter(Boolean);
            if (!opciones.length) throw new Error("No se encontraron las divisas MXN y USD en el catálogo");
            return opciones;
        } catch ({ message: label }) {
            return [{ label, value: null, disabled: true }];
        }
    }

    function formatearImporte(pImporte) {
        if (pImporte === "" || pImporte === null || pImporte === undefined) return null;
        let importe = parseFloat(pImporte);
        return isNaN(importe) ? null : importe;
    }

    function ftDiasVigencia(inicio, fin) {
        if (!inicio || !fin || !moment(inicio).isValid() || !moment(fin).isValid()) return "";
        let dias = moment(fin).startOf('day').diff(moment(inicio).startOf('day'), 'days');
        return dias < 0 ? "" : String(dias);
    }

    function formatearFecha(pFecha) {
        if (!pFecha || moment(pFecha).isValid() === false) return null;
        return moment(pFecha).format("YYYY-MM-DD");
    }

    function handleClose() {
        setOpen(false);
        setDisabled(false);
        setLoader(false);
        setNotificaciones({ ...cleanNotificaciones });
        setState({ ...cleanState });
        setErrorState({ ...cleanErrorState });
    }

    function handleCloseSemanal() {
        setDisabledSemanal(false);
        setLoaderSemanal(false);
        // Si se abrió desde "Agregar seguimiento" (sin el historial) se limpia también el padre
        if (!openVerSemanal) return handleCloseVerSemanal();
        setOpenSemanal(false);
        setNotificacionesSemanal({ ...cleanNotificaciones });
        setStateSemanal({ ...cleanStateSemanal });
        setErrorStateSemanal({ ...cleanErrorStateSemanal });
    }

    function handleCloseVerSemanal() {
        setOpenVerSemanal(false);
        setSeguimientoSeguroID(-1);
        setFolio("");
        setFechaInicioPadre("");
        setFechaFinalPadre("");
        setStateSemanal({ ...cleanStateSemanal });
        setOpenSemanal(false);
        setNotificacionesSemanal({ ...cleanNotificaciones });
        setErrorStateSemanal({ ...cleanErrorStateSemanal });
    }

    useEffect(() => {
        async function ftEffect() {
            try {
                let Empresas = await seleccionEmpresa({}, token);
                let Usuarios = await seleccionUsuarios({ filtro: {} }, token);
                let Responsables = await seleccionResponsablesSeguro({ filtro: {} }, token);
                let Divisas = await ftDivisasPermitidas();
                let Ejercicios = await seleccionEjercicioSeguros({ filtro: {} }, token);
                let Semanas = await seleccionSemanaSeguros({ filtro: {} }, token);
                let Estados = await seleccionEstadoSeguimiento({ filtro: {} }, token);
                let Tipos = await seleccionTipoSeguimiento({ filtro: {} }, token);

                setSeleccionables({ Empresas, Usuarios, Responsables, Divisas, Ejercicios, Semanas, Estados, Tipos });

                // El catálogo viene ordenado por ORDEN, así que el primero es el estado inicial ("NO INICIADA")
                let [primerEstado] = Estados.filter(({ value }) => value !== null);
                setActuales({
                    ...ftVigentesALaFecha(Ejercicios, Semanas),
                    estadoID: primerEstado ? primerEstado.value : ""
                });
            } catch ({ message }) {
                setAlert({
                    descripcion: `Algunos datos necesarios para funcionar no se cargaron correctamente, intenta actualizar la página o verifica tu conexión a internet; a continuación se muestrán más detalles del error: ${NetworkError(message)}`,
                    title: "¡Una disculpa!",
                    tipo: danger,
                    msjConfirmacion: "Aceptar",
                    onConfirm: () => setAlert(null),
                    showCancel: false
                });
            } finally {
                setCatalogosListos(true);
            }
        } ftEffect();
    }, []);

    const [accionesUsr, setAccionesUsr] = useState();
    if (accionesUsr) {
        acciones = Permisos.ValidarAcciones(acciones, accionesUsr);
        botones = Permisos.ValidarAcciones(botones, accionesUsr);
        accionesFormulario = Permisos.ValidarAcciones(accionesFormulario, accionesUsr);
    } else {
        Permisos.PermisosAState(setAccionesUsr, token);
    }

    // Captura del seguimiento semanal: dentro del historial cuando está abierto (para modificar
    // un registro y que quede encima) y fuera cuando se abre desde "Agregar seguimiento"
    const formularioSemanal = <FormularioModal
        open={openSemanal}
        title={titleModalSemanal}
        onClose={handleCloseSemanal}
        notificaciones={notificacionesSemanal}
        closeNotification={() => setNotificacionesSemanal({ ...cleanNotificaciones })}
        inputs={inputsSemanal}
        acciones={accionesFormularioSemanal}
        focus={comentarioRef}
    />;

    return (<>
        {stCatalogosListos && <Tabla
            infoTabla={infoTabla}
            asyncData={ftTablaSeguimientos}
            token={token}
        />}
        <FormularioModal
            open={open}
            title={titleModal}
            onClose={handleClose}
            notificaciones={notificaciones}
            closeNotification={() => setNotificaciones({ ...cleanNotificaciones })}
            inputs={inputs}
            acciones={accionesFormulario}
            focus={empresaIDRef}
        />
        {openVerSemanal && <Modal
            maxWidth={true}
            open={openVerSemanal}
            title={`Historial de Seguimiento ${stFolio ? "(" + stFolio + ")" : ""}`}
            onClose={handleCloseVerSemanal}
        >
            <Tabla
                infoTabla={infoTablaSemanal}
                asyncData={tablaSeguimientoSemanalSeg}
                token={token}
                parametrosFijos={{ seguimientoSeguroID: stSeguimientoSeguroID }}
            />
            {formularioSemanal}
        </Modal>}
        {!openVerSemanal && formularioSemanal}
        {openGenerarPA && <GenerarProgramaAnual
            token={token}
            onClose={() => setOpenGenerarPA(false)}
            onGenerado={(mensaje) => {
                setOpenGenerarPA(false);
                setActualizar(!actualizar);
                setAlert({
                    title: "Programa Anual",
                    descripcion: mensaje,
                    tipo: success,
                    msjConfirmacion: "Aceptar",
                    onConfirm: () => setAlert(null)
                });
            }}
        />}
        {alert && <SweetAlert
            title={alert.title}
            descripcion={alert.descripcion}
            tipo={alert.tipo}
            msjConfirmacion={alert.msjConfirmacion}
            msjCancelacion={alert.msjCancelacion}
            onConfirm={alert.onConfirm}
            showConfirm={alert.showConfirm}
            showCancel={alert.showCancel}
            onCancel={() => setAlert(null)}
        />}
    </>);
}

export default SeguimientoSeguros;
